export default "__VITE_ASSET__BcKfXT8c__"